const isBrowser = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'

const storageService = {
  getItem(key: string): string | null {
    if (!isBrowser) return null
    try {
      return window.localStorage.getItem(key)
    } catch {
      return null
    }
  },

  setItem(key: string, value: string): void {
    if (!isBrowser) return
    try {
      window.localStorage.setItem(key, value)
    } catch {
      // noop
    }
  },

  removeItem(key: string): void {
    if (!isBrowser) return
    try {
      window.localStorage.removeItem(key)
    } catch {
      // noop
    }
  },
}

export default storageService
